var types = require("./types");

var mapping = module.exports = {};

mapping.mapObjectToRequest = function(obj) {

  obj.$type = mapping.mapToRequest(obj.$type);

  if (obj.questionSet) {
    obj.questionSet.$type = mapping.mapToRequest(obj.questionSet.$type);
  }

  if (obj.questionSet.steps) {
    obj.questionSet.steps.forEach(mapping.mapStepToRequest);
  }

  return obj;
};


mapping.mapStepToRequest = function(step) {

  step.$type = mapping.mapToRequest(step.$type);

  if (step.groups) {
    step.groups.forEach(function(group) {
      group.$type = mapping.mapToRequest(group.$type);

      if (group.comparers) {
        group.comparers.forEach(function(comparer) {
          comparer.$type = mapping.mapToRequest(comparer.$type);
        });
      }

      if (group.questions) {
        group.questions.forEach(mapping.mapQuestionToRequest);
      }
    });
  }

  return step;
};


mapping.mapQuestionToRequest = function(question) {

  question.$type = mapping.mapToRequest(question.$type);

  if (question.comparers) {
    question.comparers.forEach(function(comparer) {
      comparer.$type = mapping.mapToRequest(comparer.$type);
    });
  }
  if(question.options) {
    question.options.forEach(function(option) {
      option.$type = mapping.mapToRequest(option.$type);
    });
  }

  if(question.options && question.answer) {
    question.answer.forEach(function(ans) {
      ans.$type = mapping.mapToRequest(ans.$type);
    });
  }

  if (question.$type == "GoodEx.UniversalModels.Request.ApplicationSingleDateQuestionRequest, GoodEx.UniversalModels" && question.date && question.date.indexOf("T00:00:00Z") == -1) {
    question.date += "T00:00:00Z"
  }

  return question;
};


mapping.mapToRequest = function($type) {
  var requestType;
  types.RequestMaps.forEach(function(item) {
    if (item.key == $type) {
      requestType = item.$type;
    }
  });
  return requestType;
};
